import type { FC } from 'react';
import { useSelector } from 'react-redux';
import ProfileStatItem from '../ProfileStatItem';
import ProfileHeadStats from '../ProfileHeadStats';
import { getIsGroupProfile } from '../../../../../selectors/users';
import s from './ProfileStats.scss';

interface Props {
  [stat: string]: number | string;
}

const ProfileStats: FC<Props> = ({ ...stats }) => {
  const isGroupProfile = useSelector(getIsGroupProfile);

  if (!isGroupProfile) {
    return <ProfileHeadStats stats={stats} />;
  }

  const showStats = ['founded', 'members', 'watchers'];

  return (
    <div className={s['root']}>
      {showStats.map(stat => (
        <ProfileStatItem
          key={stat}
          stat={stat}
          value={stats[stat]}
          className={s['stats-item']}
          bold={isGroupProfile}
        />
      ))}
    </div>
  );
};

export default ProfileStats;
